import {createReducer} from '../utils/redux';

import {Notification} from './actions';
import {Priority} from './constants';

const initialState = {

    /* Static Store */
    CSRFMiddlewareToken: null,

    /* Notifications Store */
    notifications: [],
    confirmNotificationURL: null,

};

export default createReducer(initialState, {
    [Notification.add]: ({notifications}, notification) => ({
        notifications: [...notifications, notification],
    }),
    [Notification.confirm]: ({notifications}, id) => ({
        notifications: notifications.filter(notification => notification.id !== id),
    }),
    [Notification.initial]: (state, {url, notifications, ...data}) => ({
        ...data,
        confirmNotificationURL: url,
        notifications: notifications.map(notification => ({
            ...notification,
            priority: Priority.LOW,
        })),
    }),
});
